import { Account } from "@/types";

interface ValueDiscoveryFrameworkProps {
    valueDiscoveryFrameworks?: NonNullable<Account['valueDiscoveryFramework']>
}

export default function ValueDiscoveryFramework({valueDiscoveryFrameworks = []}: ValueDiscoveryFrameworkProps) {
    return (
        <div className="overflow-x-auto">
            <table className="w-full border-collapse">
                <thead>
                <tr className="border-b border-neutral-200 dark:border-dark-border-light">
                    <th className="text-left py-3 px-4 text-sm font-semibold text-slate-900 dark:text-neutral-50 bg-slate-50 dark:bg-slate-800">
                        Use-case family / KPI category
                    </th>
                    <th className="text-left py-3 px-4 text-sm font-semibold text-slate-900 dark:text-neutral-50 bg-slate-50 dark:bg-slate-800">
                        Representative functions / use cases
                    </th>
                    <th className="text-left py-3 px-4 text-sm font-semibold text-slate-900 dark:text-neutral-50 bg-slate-50 dark:bg-slate-800">
                        Primary KPI targets (examples)
                    </th>
                    <th className="text-left py-3 px-4 text-sm font-semibold text-slate-900 dark:text-neutral-50 bg-slate-50 dark:bg-slate-800">
                        Relevant KPI drivers
                    </th>
                </tr>
                </thead>
                <tbody>
                {valueDiscoveryFrameworks.map((item, index) => (
                    <tr
                        key={index}
                        className="border-b border-neutral-200 dark:border-dark-border-light hover:bg-slate-50 dark:hover:bg-slate-800/50 transition-colors"
                    >
                        <td className="py-4 px-4 text-sm text-slate-900 dark:text-neutral-50 font-medium align-top">
                            <div className="min-w-0">
                                {item.product_name}
                            </div>
                        </td>
                        <td className="py-4 px-4 text-sm text-slate-600 dark:text-neutral-300 align-top">
                            <div className="min-w-0">
                                {item.product_components}
                            </div>
                        </td>
                        <td className="py-4 px-4 text-sm text-slate-600 dark:text-neutral-300 align-top">
                            <div className="min-w-0">
                                {item.kpis}
                            </div>
                        </td>
                        <td className="py-4 px-4 text-sm text-slate-600 dark:text-neutral-300 align-top">
                            <div className="min-w-0">
                                {item.kpi_drivers}
                            </div>
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    )
}